import store from '@/store/store';

class FeatureFlag {
    getFlag(flagKey) {
        // ログインユーザーが変更になる可能性があるのでコンストラクタで定義せずに毎回呼び出す
        const userId = store.state.user.status.sub;
        const organizationId =
            store.getters['view/organization'].organizationId;
        const enabledUsers = this.parseUsers(flagKey);
        const enabledOrganizations = this.parseOrganizations(flagKey);
        const enabledFlag = this.enabledFlag(flagKey);

        if (enabledFlag === 'OFF') {
            return false;
        } else if (enabledFlag === 'END') {
            return true;
        }
        if (
            enabledUsers.includes(userId) ||
            enabledOrganizations.includes(organizationId)
        ) {
            return true;
        }
        return false;
    }

    enabledFlag(flagKey) {
        const flag = process.env[`VUE_APP_FEATURE_${flagKey}`];
        if (!flag) {
            return 'OFF';
        }
        return flag;
    }

    parseUsers(flagKey) {
        const envUsers = process.env[`VUE_APP_FEATURE_${flagKey}_USERS`];
        if (!envUsers) {
            return [];
        }
        return envUsers.split(',');
    }

    parseOrganizations(flagKey) {
        const envOrganizations =
            process.env[`VUE_APP_FEATURE_${flagKey}_ORGANIZATIONS`];
        if (!envOrganizations) {
            return [];
        }
        return envOrganizations.split(',');
    }
}

export default new FeatureFlag();
